const configuredApiBase = import.meta.env.VITE_API_BASE_URL?.replace(/\/$/, '') ?? '';

export const API_BASE_URL = configuredApiBase;
const contactEndpoint = API_BASE_URL ? `${API_BASE_URL}/contact` : '/api/contact';

export async function postContact<TResponse = { success?: boolean; message?: string }>(payload: unknown): Promise<TResponse> {
  const response = await fetch(contactEndpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  const result = await response.json();
  if (!response.ok) {
    throw new Error(typeof result?.message === 'string' ? result.message : 'No fue posible enviar el mensaje.');
  }

  return result as TResponse;
}
